import { useQuery } from '@tanstack/react-query'
import { fetchPoolRoster, fetchWeekPicks } from './api'

export function useWeekPicks(poolId: string | undefined, weekId: string | undefined) {
  return useQuery({
    queryKey: ['board', 'picks', poolId, weekId],
    queryFn: () => fetchWeekPicks(poolId!, weekId!),
    enabled: Boolean(poolId && weekId),
    /* Picks for a locked week are immutable -- there is no DELETE policy and
       both UPDATE policies require the week to still be open -- so once this
       has resolved for a locked week it can never go stale. The games query
       carries the live polling; nothing here needs to move. */
    staleTime: Infinity,
  })
}

export function usePoolRoster(poolId: string | undefined) {
  return useQuery({
    queryKey: ['board', 'roster', poolId],
    queryFn: () => fetchPoolRoster(poolId!),
    enabled: Boolean(poolId),
    staleTime: 5 * 60_000,
  })
}
